
import { defineComponent } from 'vue';
import { IDmvtGrouppedTkItem } from '@/core/interfaces/ApiResponses';

export default defineComponent({
  name: 'DmvtTkGroupped',

  props: {
    data: {
      type: Array as () => IDmvtGrouppedTkItem[],
      default: () => [],
    },
    emptyMessage: {
      type: String,
      default: 'Không có dữ liệu',
    },
    badgeClass: {
      type: String,
      default: 'badge badge-light-primary',
    },
    emptyMessageClass: {
      type: String,
      default: 'text-danger',
    },
  },
});
